<ng-container *ngIf="vm$ | async as vm">
  <!-- Error con reintento -->
  <div class="od-alert" role="alert" *ngIf="vm.error && !vm.datos">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx">
      <b>No se pudo traer el resumen</b>
      <p class="od-muted">{{ vm.error }}</p>
    </div>
    <button type="button" class="od-btn od-btn-sm" (click)="recargar()"><od-icon name="refresh"></od-icon>Reintentar</button>
  </div>

  <!-- Cargando por primera vez -->
  <div *ngIf="vm.cargando && !vm.datos" aria-busy="true" aria-label="Cargando el resumen">
    <div class="od-skeleton" style="height: 46px; margin-bottom: 12px"></div>
    <div class="od-kpis"><div class="od-skeleton" style="height: 84px" *ngFor="let i of esperaSkeleton; trackBy: porIndice"></div></div>
    <div class="od-grid2"><div class="od-skeleton" style="height: 190px"></div><div class="od-skeleton" style="height: 190px"></div></div>
  </div>

  <ng-container *ngIf="vm.datos as v">
    <!-- Conexión -->
    <div class="od-alert od-alert-flat" [attr.role]="v.conectado ? null : 'alert'">
      <od-icon [name]="v.conectado ? 'check' : 'alert'" [size]="16"></od-icon>
      <div class="od-alert-tx">
        <b>{{ v.conexionTitulo }}</b>
        <span class="od-muted" *ngIf="v.conexionDetalle"> · {{ v.conexionDetalle }}</span>
      </div>
      <button type="button" class="od-btn" (click)="probar()" [disabled]="probando$ | async">
        <od-icon name="refresh" [ngClass]="{ 'od-spin': probando$ | async }"></od-icon>Probar conexión
      </button>
    </div>

    <!-- Cifras -->
    <div class="od-kpis">
      <div class="od-kpi">
        <span class="od-muted">Anotados en Odoo</span>
        <b>{{ v.anotadosClientes }}</b>
        <span class="od-muted">{{ v.anotadosComercios }}</span>
      </div>
      <div class="od-kpi">
        <span class="od-muted">Esperando envío</span>
        <b>{{ v.r.maestros.pendientes }}</b>
        <span class="od-muted">{{ v.reintento }}</span>
      </div>
      <div class="od-kpi" [class.od-kpi-hi]="v.r.maestros.errores > 0">
        <span class="od-muted">Con problema</span>
        <b>{{ v.r.maestros.errores }}</b>
        <span class="od-muted">{{ v.problemaPie }}</span>
      </div>
      <div class="od-kpi">
        <span class="od-muted">Próximo archivo</span>
        <b>{{ v.proxDia }}</b>
        <span class="od-muted">{{ v.proxHora }}</span>
      </div>
    </div>

    <div class="od-grid2">
      <!-- Últimos archivos, por día -->
      <section class="od-sec">
        <h5>Últimos archivos</h5>
        <div class="od-empty" *ngIf="!v.dias.length">
          <od-icon name="file" [size]="20"></od-icon>
          <b>Todavía no se ha subido ningún archivo</b>
          <span>Aparecerán aquí cuando se generen.</span>
        </div>
        <div class="od-ev" *ngFor="let d of v.dias; trackBy: porFecha">
          <span class="od-ev-tx"><b>{{ d.titulo }}</b><br><span class="od-muted">{{ d.detalle }}</span></span>
          <span class="od-badge od-badge-solid" *ngIf="d.ok"><od-icon name="check"></od-icon>Subido</span>
          <span class="od-badge od-badge-problem" *ngIf="!d.ok"><od-icon name="alert"></od-icon>No se pudo subir</span>
        </div>
      </section>

      <!-- Cómo está funcionando -->
      <section class="od-sec">
        <h5>Cómo está funcionando</h5>
        <div style="display: flex; flex-direction: column; align-items: flex-start; gap: 8px; margin-top: 8px">
          <span class="od-chip" *ngFor="let c of v.chips; trackBy: porTexto"><od-icon [name]="c.icono"></od-icon>{{ c.texto }}</span>
        </div>
      </section>
    </div>
  </ng-container>
</ng-container>
